import { Box, Modal } from "@mui/material";
import { useMyContext } from "../../context";
import { modalStyle } from "../../MUIStyles";
import useSupport from "../../hooks/useSupport";

const formatDate = (dateString) => {
  if (!dateString) return "-";

  try {
    return new Date(dateString).toLocaleString();
  } catch {
    return dateString;
  }
};

const DisputeTypesList = () => {
  const { modalStates, handleCloseModal, openModal, handleOpenModal, setId } =
    useMyContext();
  const { distputTypes, distputTypesIsError, distputTypesLoading } =
    useSupport();

  const handleClose = () => {
    handleCloseModal("disputeTypesList");
  };

  const handleAddNew = () => {
    setId("");
    handleClose();
    handleOpenModal("addEditDistput");
  };

  const list = Array.isArray(distputTypes?.data) ? distputTypes.data : [];

  return (
    <Modal open={modalStates.disputeTypesList} onClose={handleClose}>
      <Box
        sx={{
          ...modalStyle,
          maxHeight: "90vh",
          width: { lg: "900px", xs: "95vw", sm: "700px" },
          overflowY: "auto",
        }}
      >
        <div className="flex flex-col gap-5">
          <div className="flex items-center justify-between gap-4 flex-wrap">
            <div>
              <h2 className="text-xl font-semibold">Dispute Types</h2>
              <p className="text-sm text-gray-500 mt-1">
                Manage dispute categories used across the disputes center
              </p>
            </div>
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={handleAddNew}
                className="inline-flex items-center gap-2 h-10 px-4 rounded-xl bg-primary text-white text-sm font-semibold hover:opacity-90 transition cursor-pointer shadow-sm"
              >
                <span className="text-lg leading-none">+</span>
                Add New
              </button>
              <button
                type="button"
                onClick={handleClose}
                className="w-10 h-10 rounded-xl border border-gray-200 text-gray-500 hover:text-gray-700 hover:bg-gray-50 transition cursor-pointer"
                aria-label="Close"
              >
                ✕
              </button>
            </div>
          </div>

          <div className="overflow-x-auto rounded-xl border border-gray-200">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 text-left">
                <tr>
                  <th className="px-4 py-3 font-semibold">ID</th>
                  <th className="px-4 py-3 font-semibold">Arabic Name</th>
                  <th className="px-4 py-3 font-semibold">English Name</th>
                  <th className="px-4 py-3 font-semibold">Status</th>
                  <th className="px-4 py-3 font-semibold">Created At</th>
                  <th className="px-4 py-3 font-semibold text-center">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {distputTypesLoading ? (
                  <tr>
                    <td
                      colSpan={6}
                      className="px-4 py-8 text-center text-gray-500"
                    >
                      Loading types...
                    </td>
                  </tr>
                ) : distputTypesIsError ? (
                  <tr>
                    <td
                      colSpan={6}
                      className="px-4 py-8 text-center text-red-500"
                    >
                      Error loading dispute types
                    </td>
                  </tr>
                ) : list.length > 0 ? (
                  list.map((type) => (
                    <tr key={type.id || type._id} className="border-t border-gray-100">
                      <td className="px-4 py-3">#{type.id}</td>
                      <td className="px-4 py-3" dir="rtl">
                        {type.name_ar || "-"}
                      </td>
                      <td className="px-4 py-3">{type.name_en || "-"}</td>
                      <td className="px-4 py-3">
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium ${
                            type.is_active
                              ? "bg-green-100 text-green-700"
                              : "bg-gray-100 text-gray-600"
                          }`}
                        >
                          {type.is_active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        {formatDate(type.created_at)}
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center justify-center gap-3">
                          <button
                            type="button"
                            className="text-secondary text-sm font-medium cursor-pointer hover:underline"
                            onClick={() => {
                              handleClose();
                              openModal("addEditDistput", type.id);
                            }}
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="text-bg10 text-sm font-medium cursor-pointer hover:underline"
                            onClick={() => {
                              handleClose();
                              openModal("delete", type.id);
                            }}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="px-4 py-10 text-center">
                      <p className="text-gray-500 mb-4">No dispute types found</p>
                      <button
                        type="button"
                        onClick={handleAddNew}
                        className="inline-flex items-center gap-2 h-10 px-4 rounded-xl bg-primary text-white text-sm font-semibold hover:opacity-90 transition cursor-pointer"
                      >
                        <span className="text-lg leading-none">+</span>
                        Add New Type
                      </button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default DisputeTypesList;
